export default function About() {
    return (
        <main data-testid="about-page" className="bg-black min-h-screen pt-32 pb-24">
            <div className="container-luxury max-w-4xl">
                <div className="overline mb-6">About</div>
                <h1 className="font-serif text-5xl sm:text-6xl tracking-tight leading-[0.95] mb-12">A new way to experience tile.</h1>
                <div className="space-y-8 text-white/80 text-lg leading-relaxed font-serif">
                    <p>TileSphere brings together completed projects from a curated network of premium tile houses — and assembles them into one cinematic catalog designed for clients, architects, and interior designers.</p>
                    <p>Walk-in clients can browse on a wall-mounted display in showrooms. Designers can scout inspiration from a phone. Sales agents can showcase their portfolio in seconds.</p>
                    <p className="text-gold">It's a digital flagship — not just a gallery.</p>
                </div>
            </div>
        </main>
    );
}
